import { defineMessages } from 'react-intl';

export const i18n: {
	positionFilterFocusAreaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionFilterFocusAreaPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionFilterFocusAreaLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionFilterFocusAreaLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	positionFilterFocusAreaLabel: {
		id: 'search-page.filters.names.positionFocusArea',
		defaultMessage: 'Focus area',
		description: 'Label for filtering by content focus area',
	},
	positionFilterFocusAreaPlaceholder: {
		id: 'search-page.talent.filter.focus-area.content.placeholder',
		defaultMessage: 'Find focus areas',
		description: 'Placeholder for content filter search input',
	},
	positionFilterFocusAreaLabelSelected: {
		id: 'search-page.talent.filter.focus-area.content.selected',
		defaultMessage: 'Selected',
		description:
			'The text is shown as a section heading in the talent position focus area filter drop-down, grouping focus areas the user has already chosen.',
	},
	positionFilterFocusAreaLabelUnselected: {
		id: 'search-page.talent.filter.focus-area.content.unselected',
		defaultMessage: 'Suggested',
		description:
			'The text is shown as a section heading in the talent position focus area filter drop-down, grouping recommended focus areas not yet selected.',
	},
});
